'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = urlMiddleware;

var _utils = require('../utils');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
/* eslint-disable no-param-reassign */

function urlMiddleware(opts) {
  var urlOrThunk = opts && opts.url || '/graphql';
  var fetchOpts = opts && opts.opts || null;

  return function (next) {
    return function (req) {
      if (fetchOpts) {
        var _headers = fetchOpts.headers,
            otherOpts = _objectWithoutProperties(fetchOpts, ['headers']);

        Object.assign(req, otherOpts);
        if (_headers) {
          Object.assign(req.headers, _headers);
        }
      }

      if (req.relayReqType !== 'batch-query') {
        // $FlowFixMe
        req.url = (0, _utils.isFunction)(urlOrThunk) ? urlOrThunk(req) : urlOrThunk;
      }

      return next(req);
    };
  };
}